@if (selectedItems() && (selectedItems()?.length ?? 0) > 0) {
  <div class="clear-btn">
    <p-button
      icon="fa fa-eraser"
      styleClass="nav-button"
      (click)="onClearSelections()"
      pTooltip="{{ 'COMMON.TOOLTIPS.CLEAR_SELECTIONS' | translate }}"
      tooltipPosition="left"
      placeholder="Left"
    />
  </div>
}
<div class="export-btn">
  <p-button
    icon="fa fa-download"
    (click)="onExportCSV()"
    styleClass="nav-button"
    pTooltip="{{ 'COMMON.TOOLTIPS.EXPORT_TO_CSV' | translate }}"
    tooltipPosition="left"
    placeholder="Left"
  />
</div>
